<template>
	<!-- 
		ImgInputAutoload

		V.1.1
		Actualizaciones varias de rendimiento
        @author Daniel Lepe 2022

		V.1.0
		PARA LA INTEGRACIÓN DE IMÁGENES REQUIERE 
		EL CONTROLADOR UiController.php y UiModel.php en la API Base

		@Author Daniel Lepe 2021
	-->
	<b-row no-gutters class="ui-file-image-autoupload" align-v="center">
		<b-col v-if="isProcessing">
			<spinner></spinner>
		</b-col>

		<template v-else>

			<b-col cols="auto" v-if="!isProcessing">
				<api-img class="responsive uploaded-img" :allow-pdf="allowPdf" :comp="value" />
			</b-col>

			<b-col class="pl-3">
				<label v-if="label != 'false'" :for="workingId">{{ computedLabel }}</label>

				<div class="check" v-if="hasBeenProcessed && allowPdf">
					<i class="fa fa-check"></i>
				</div>
				<!-- <input v-else-if="displayingInput" type="file" :id="workingId" @change="fileUpdate($event)" :disabled="readonlyAllowed" :accept="accept"/> -->
				<b-form-file
					v-else-if="displayingInput"
					:id="workingId"
					:disabled="readonlyAllowed"
					:accept="accept"
					@change="fileUpdate($event)"
					:label="computedLabel"
					:placeholder="readonlyAllowed? '--': 'Select the file or drop it here...'"
					:drop-placeholder="readonlyAllowed? '--': 'Drop it...'"
				/>
			</b-col>

		</template>

	</b-row>
</template>

<script>
    import _ from "lodash";
    import moment from "moment";
    import axios from "axios";
    import swal from "sweetalert";

    moment.locale("es");

    export default {
        data() {
            return {
                hasBeenProcessed: false,
                file: null,
                displayingInput: true,
                isProcessing: false,
                workingId: null
            };
        },

        props: {
            setBusy: {
                type: [Function, Object],
                default: null,
            },
            setUnBusy: {
                type: [Function, Object],
                default: null,
            },
            label: {
                type: [Number, String],
                default: null,
            },
            value: {
                type: [Number, String],
                default: null,
            },
            id: {
                type: [Number, String],
                default: null,
            },
            readonly: {
                type: [Number, String, Boolean],
                default: false,
            },
            allowPdf: {
                type: [Number, String, Boolean],
                default: false,
            },
        },

        computed: {
            storageURI() {
                return this.allowPdf ? "ui/storevault" : "ui/storepicture";
            },
            readonlyAllowed() {
                return (!!this.readonly || (!!this.allowPdf && this.allowPdf != 'false'))? true : false;
            },
            computedLabel() {
                return !!this.label ? this.label : "Label";
            },
            accept() {
                if (this.allowPdf) {
                    return "application/pdf, image/png, image/jpeg, image/jpg";
                } else {
                    return "image/png, image/jpeg, image/jpg";
                }
            },
        },

        methods: {
            fileUpdate($event) {
                if ($event.srcElement.files[0])
                    this.file = $event.srcElement.files[0];
                if (this.file != null && this.file.size > 6 * 1024 * 1024) {
                    swal(
                        "Espera un momento",
                        "La imágene debe ser menor de 6 MB",
                        "info"
                    ).then(() => {
                        this.file = null;
                        this.refresh();
                    });
                } else if (this.file != null && this.file.size) {
                    this.tryUpload();
                }
            },
            triggerModelUpdate($event) {
                this.$emit("input", $event.target.value);
            },
            tryUpload() {
                this.isProcessing = true;
                var data = new FormData();
                data.append("imagen", this.file, this.file.name);
                if (typeof this.setBusy == "function") this.setBusy();
                axios
                    .post(this.storageURI, data, {
                        headers: {
                            accept: "application/json",
                            "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
                        },
                    })
                    .then((r) => {
                        console.log("r", r);
                        setTimeout(()=>{
                            this.isProcessing = false;
                        }, 150)
                        if (typeof this.setUnBusy == "function") this.setUnBusy();
                        if (r.status) {
                            this.hasBeenProcessed = true;
                            this.$emit("input", r.data["img"]);
                        }
                    })
                    .catch((e) => {
                        this.isProcessing = false;
                        if (typeof this.setUnBusy == "function") this.setUnBusy();
                        alert(
                            "El servidor a cerrado la conexión, por favor intenta con imágenes mas pequeñas."
                        );
                    });
            },
            refresh() {
                this.displayingInput = false;
                this.isProcessing = false;
                setTimeout(() => {
                    this.displayingInput = true;
                }, 50);
            },
        },

        beforeMount() {
            if (!this.id) {
                this.workingId = _.uniqueId("ui-file-image-autoupload-");
            } else {
                this.workingId = this.id;
            }
        },
    };
</script>

<style lang="less">
.ui-file-image-autoupload{
    .uploaded-img {
        width: 5em;
        height: 5em;
    }
}
</style>